import { render } from "./NewCrawlReady.vue?vue&type=template&id=e059a4ba&scoped=true"
import script from "./NewCrawlReady.vue?vue&type=script&lang=js"
export * from "./NewCrawlReady.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e059a4ba"

export default script